module.exports = __webpack_public_path__ + "img/746778a.png";